import { render, staticRenderFns } from "./RouteBox.vue?vue&type=template&id=f3044cec&scoped=true&"
import script from "./RouteBox.vue?vue&type=script&lang=js&"
export * from "./RouteBox.vue?vue&type=script&lang=js&"
import style0 from "./RouteBox.vue?vue&type=style&index=0&id=f3044cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3044cec",
  null
  
)

export default component.exports